module.exports = __webpack_public_path__ + "img/faq-bg.fb4adb38.png";